var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "postBlock" }, [
      _c(
        "div",
        { staticClass: "postAlign" },
        [
          _c("h3", { staticClass: "form-group" }, [
            _vm._v(_vm._s(_vm.getForumTitle))
          ]),
          _vm._v(" "),
          !_vm.inWhoInSection
            ? _c("base-input", {
                staticClass: "form-group",
                attrs: { placeholder: _vm.$t("enterPostTitle") },
                model: {
                  value: _vm.postTitle,
                  callback: function($$v) {
                    _vm.postTitle = $$v
                  },
                  expression: "postTitle"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.inWhoInSection
            ? _c(
                "div",
                [
                  _c("base-select", {
                    staticClass: "mb-4",
                    attrs: {
                      placeholder: _vm.$t("activity"),
                      valueProp: "id",
                      avoidDefaultSort: "",
                      options: _vm.activitySource,
                      searchable: "",
                      label: _vm.normalizeForumProp("name")
                    },
                    on: { "option:selected": _vm.activityChange },
                    model: {
                      value: _vm.whoInData.activity,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "activity", $$v)
                      },
                      expression: "whoInData.activity"
                    }
                  }),
                  _vm._v(" "),
                  _vm.otherActivitySelected
                    ? _c("base-input", {
                        staticClass: "form-group",
                        attrs: { placeholder: _vm.$t("insertActivityName") },
                        model: {
                          value: _vm.whoInData.otherActivity,
                          callback: function($$v) {
                            _vm.$set(_vm.whoInData, "otherActivity", $$v)
                          },
                          expression: "whoInData.otherActivity"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("base-select", {
                    staticClass: "mb-4",
                    attrs: {
                      placeholder: _vm.$t("level"),
                      avoidDefaultSort: "",
                      valueProp: "id",
                      options: _vm.activityLevelSource,
                      searchable: "",
                      label: _vm.normalizeForumProp("name")
                    },
                    model: {
                      value: _vm.whoInData.activityLevel,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "activityLevel", $$v)
                      },
                      expression: "whoInData.activityLevel"
                    }
                  }),
                  _vm._v(" "),
                  _c("base-input", {
                    staticClass: "form-group",
                    attrs: {
                      type: "number",
                      min: 2,
                      placeholder:
                        _vm.$t("participantsLimit") + " " + _vm.$t("optional")
                    },
                    model: {
                      value: _vm.whoInData.participantsLimit,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "participantsLimit", $$v)
                      },
                      expression: "whoInData.participantsLimit"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.countrySource,
                              placeholder: _vm.$t("country"),
                              valueProp: "idCountry",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name")
                            },
                            on: { "option:selected": _vm.countryChange },
                            model: {
                              value: _vm.whoInData.country,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "country", $$v)
                              },
                              expression: "whoInData.country"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.stateSource,
                              placeholder: _vm.$t("state"),
                              valueProp: "id",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name")
                            },
                            on: { "option:selected": _vm.stateChange },
                            model: {
                              value: _vm.whoInData.state,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "state", $$v)
                              },
                              expression: "whoInData.state"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-select", {
                            attrs: {
                              options: _vm.citySource,
                              placeholder: _vm.$t("city"),
                              valueProp: "idCity",
                              searchable: "",
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              loading: false,
                              noOptionsTitle: _vm.$t("selectState")
                            },
                            model: {
                              value: _vm.whoInData.city,
                              callback: function($$v) {
                                _vm.$set(_vm.whoInData, "city", $$v)
                              },
                              expression: "whoInData.city"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("base-input", {
                    staticClass: "form-group",
                    attrs: { placeholder: _vm.$t("address") },
                    model: {
                      value: _vm.whoInData.address,
                      callback: function($$v) {
                        _vm.$set(_vm.whoInData, "address", $$v)
                      },
                      expression: "whoInData.address"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-datepicker", {
                            attrs: {
                              noMarginBottom: "",
                              dateAfterNow: "",
                              resetButtton: "",
                              placeholder:
                                _vm.$t("startDate") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.startDate,
                              callback: function($$v) {
                                _vm.startDate = $$v
                              },
                              expression: "startDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-timepicker", {
                            attrs: {
                              noMarginBottom: "",
                              buttonOnly: "",
                              placeholder:
                                _vm.$t("startHour") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.startHour,
                              callback: function($$v) {
                                _vm.startHour = $$v
                              },
                              expression: "startHour"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-4", attrs: { cols: "12", xl: "4" } },
                        [
                          _c("base-datepicker", {
                            attrs: {
                              noMarginBottom: "",
                              dateAfterNow: "",
                              resetButtton: "",
                              placeholder:
                                _vm.$t("endDate") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.endDate,
                              callback: function($$v) {
                                _vm.endDate = $$v
                              },
                              expression: "endDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-4",
                          attrs: { cols: "12", xl: "3", "offset-xl": "1" }
                        },
                        [
                          _c("base-timepicker", {
                            attrs: {
                              noMarginBottom: "",
                              buttonOnly: "",
                              placeholder:
                                _vm.$t("endHour") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.endHour,
                              callback: function($$v) {
                                _vm.endHour = $$v
                              },
                              expression: "endHour"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("b-form-file", {
                    staticClass: "form-group",
                    attrs: {
                      accept: ".jpg, .jpeg, .png, .gif",
                      placeholder: _vm.$t("selectImage"),
                      multiple: false,
                      "drop-placeholder": _vm.$t("drag-drop-file"),
                      "browse-text": _vm.$t("browse")
                    },
                    model: {
                      value: _vm.postImage,
                      callback: function($$v) {
                        _vm.postImage = $$v
                      },
                      expression: "postImage"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showtagsSelector
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          multiple: "",
                          placeholder: _vm.$t("mustEnterEntryTags"),
                          options: _vm.tagsSource,
                          filtered: "",
                          searchable: "",
                          label: _vm.normalizeForumProp("name")
                        },
                        on: {
                          "option:selected": _vm.updateTagsSource,
                          "option:deselecting": function($event) {
                            return _vm.tagDeselected($event)
                          },
                          search: _vm.getTags
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("noTagsAvailables")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1607747767
                        ),
                        model: {
                          value: _vm.tags,
                          callback: function($$v) {
                            _vm.tags = $$v
                          },
                          expression: "tags"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCategorySelector
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          placeholder: _vm.$t("mustEnterEntryCategory"),
                          options: _vm.categoriesSource,
                          filtered: "",
                          searchable: "",
                          label: _vm.normalizeForumProp("name")
                        },
                        on: {
                          search: _vm.getCategories,
                          "option:selected": _vm.categorySelected
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("mustEnterEntryCategory")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          293695534
                        ),
                        model: {
                          value: _vm.category,
                          callback: function($$v) {
                            _vm.category = $$v
                          },
                          expression: "category"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDiseaseInput
                    ? _c("v-select", {
                        staticClass: "select-margin-bottom",
                        attrs: {
                          taggable: "",
                          placeholder: _vm.$t("enterOrSearchDiseases"),
                          options: _vm.diseasesSource,
                          filtered: "",
                          searchable: "",
                          label: "name"
                        },
                        on: { "option:created": _vm.inputNewDisease },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(_vm.$t("enterOrSearchDiseases")) +
                                      "\r\n          "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3232003289
                        ),
                        model: {
                          value: _vm.disease,
                          callback: function($$v) {
                            _vm.disease = $$v
                          },
                          expression: "disease"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _c("vue-editor", {
            staticClass: "wysiwygStyle form-group",
            attrs: {
              placeholder: _vm.inWhoInSection
                ? _vm.$t("commentaries")
                : _vm.$t("newPostDescription"),
              useCustomImageHandler: ""
            },
            on: { "image-added": _vm.handleImageAdded },
            model: {
              value: _vm.wysiwygInput,
              callback: function($$v) {
                _vm.wysiwygInput = $$v
              },
              expression: "wysiwygInput"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10%", "margin-top": "3%" } },
            [
              _c("base-button", { on: { click: _vm.sendForumForm } }, [
                _vm._v(_vm._s(_vm.$t("send")))
              ]),
              _vm._v(" "),
              _c(
                "base-button",
                { attrs: { gray: "", outline: "" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("back")))]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a74d1350", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a74d1350","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/ForumNewPostForm.vue
// module id = 4311
// module chunks = 79